var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-adress-container"},[_c('van-address-edit',{attrs:{"area-list":_vm.areaList,"show-set-default":"","address-info":_vm.AddressInfo,"area-columns-placeholder":['请选择', '请选择', '请选择']},on:{"save":_vm.onSave}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }